import React from "react";
import Title from "./Title";

class WebCemeteriesRecentObituariesComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            pageData: {
                body: {
                }
            }
        }
    }

    async componentDidMount() {
        const script = document.createElement('script');

        script.src = "https://apps.remembermyjourney.com/recent-obituaries/app.js";
        script.async = true;
      
        document.body.appendChild(script);
      
        return () => {
          document.body.removeChild(script);
        };
    }

    render() {
        return (
            <div className="webCemeteries-page-wrapper">
                <h1>Recent and Upcoming Burials</h1>
                <div id="webcem-recent-obits" data-key="8yP9DMYqpb3OWJmjnGPKJeQo0r1ALn" data-cemetery="6BmZ88ow" data-future-days="30" data-past-days="60" data-use-dod="false" data-primary="#FFFFFF" data-secondary="#e9e8e7" data-accent="#a59c94" data-text="#000000"></div>
                    <script async src="https://apps.remembermyjourney.com/recent-obituaries/app.js" charset="utf-8"></script>
                    </div>
        );
    }
}

export default WebCemeteriesRecentObituariesComponent;